export const en = {
    'adgroup-demography-multipliers': 'Group bid adjustments for gender and age',
    'adgroup-mobile-multiplier': 'Group bid adjustments for mobile',
    'adgroup-performance-tgo-multiplier': 'Group bid adjustments for smart ads',
    'adgroup-regions': 'Display region for group',
    'adgroup-retargeting-multipliers': 'Group bid adjustments for retargeting',
    'adgroup-video-multiplier': 'Group bid adjustments for video extensions',
    'banner-status': 'Ad status',
    'banners-archived': 'Ad moved to archive',
    'banners-hide': 'Ad stopped',
    'banners-show': 'Ad enabled',
    'banners-unarchived': 'Ad unarchived',
    'campaign-archived': 'Campaign moved to archive',
    'campaign-broad-match': 'Related keywords',
    'campaign-creation': 'Campaign created',
    'campaign-demography-multipliers': 'Bid adjustments for gender and age',
    'campaign-disabled-domains': 'Blocked sites',
    'campaign-disabled-ips': 'Blocked IP addresses',
    'campaign-disabled-ssp': 'Blocked ad exchanges',
    'campaign-extended-geotargeting': 'Extended geotargeting',
    'campaign-finish-time': 'Campaign end date',
    'campaign-hide': 'Campaign stopped',
    'campaign-minus-words': 'Negative keywords for campaign',
    'campaign-mobile-multiplier': 'Bid adjustments for mobile',
    'campaign-network': 'Settings in ad networks',
    'campaign-performance-tgo-multiplier': 'Bid adjustments for smart ads',
    'campaign-regions': 'Display region',
    'campaign-restrict-frequency': 'Limit frequency of impressions',
    'campaign-retargeting-multipliers': 'Bid adjustments for retargeting',
    'campaign-show': 'Campaign enabled',
    'campaign-start-time': 'Campaign start date',
    'campaign-status': 'Campaign status',
    'campaign-strategy': 'Strategy',
    'campaign-time-target': 'Time targeting',
    'campaign-unarchived': 'Campaign unarchived',
    'campaign-video-multiplier': 'Bid adjustments for video extensions',
    off: 'Off',
    on: 'On',
    yandex: 'Yandex'
};
